export const CANNY_APP_ID = '624f210921b1f7528dab3be1';
